export const Pattern = {
  LETTERS_ONLY: '^(?! +$)[A-Za-z][A-Za-z ]*$',
  LETTERS_NUMBERS_ONLY: '^(?! +$)[A-Za-z0-9 ]+$',
  NUMBERS_ONLY: '^[0-9]*$',
  PASSWORD:
    '^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*()_+=-])[A-Za-z0-9!@#$%^&*()_+=-]{4,}$',
  EMAIL: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9]+([.-][a-zA-Z0-9]+)*\\.[a-zA-Z]{2,}$',
  PHONE: '^(?:[0-9!@#$%^&*()_+=-]?){1,}[0-9!@#$%^&*()_+=-]$',
  PRICE: '^[0-9]+(.[0-9]+)?$',
};
